import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import ExpandableWrapper from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/ExpandableWrapper';
import useExpandable from 'Hooks/useExpandable';
import {
  selectAssetDetailId,
  selectHostDetailSeverityCounts
} from 'store/Contextualization/AssetDetail/selectors';
import {
  Wrapper, ProgressBar, EmptyState
} from './styled';

const ID = 'importantVulnerabilities';

const ImportantVulnerabilities = () => {
  const intl = useIntl();
  const hostId = useSelector(selectAssetDetailId);
  const severityCounts = useSelector(selectHostDetailSeverityCounts) || {};
  const isExpanded = useExpandable('general', ID, true, hostId);
  const critical = severityCounts.critical || 0;
  const high = severityCounts.high || 0;
  const med = severityCounts.med || severityCounts.medium || 0;
  const total = severityCounts.total || critical + high + med;
  const hasImportantVulnerabilities = total > 0 && (critical + high + med) > 0;
  const normalizedSeverityCounts = {
    ...severityCounts,
    critical,
    high,
    med,
    total
  };

  return (
    <ExpandableWrapper id={ ID } title={ intl.formatMessage({ id: 'host.hostDetail.importantVulnerabilities' }) } defaultValue={ isExpanded } tab="general">
      <Wrapper>
        {hasImportantVulnerabilities
          ? <ProgressBar value={ normalizedSeverityCounts } />
          : <EmptyState>—</EmptyState>}
      </Wrapper>
    </ExpandableWrapper>
  );
};

export default ImportantVulnerabilities;
